import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IModifiersContext, ModifiersContext } from '../../modifiersState/modifiersContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Modifiers.module.scss';

const Modifiers: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, modifiers, currentPage, countOfItems } = useContext<IModifiersContext>(ModifiersContext);

	return (
		<>
			{modifiers.modifiersCount ? (
				<div className={style.container} data-test="Modifiers">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={modifiers.modifiersCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Modifiers;
